export const appBar = {
  noProfileSelected: "Selecionar perfil",
  logout: "Sair"
};
